var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 393,
    viewBox: "0 0 356 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.287 76.8543C114.625 104.861 115.194 162.524 117.187 187.855C123.164 151.993 135.128 141.56 161.587 125.524C189.764 108.447 272.588 116.131 308.449 111.862C344.311 107.593 362.242 68.3158 353.703 40.9926C346.872 19.1341 327.234 4.27709 310.157 0.861694H228.187C175.249 0.861694 145.364 41.8465 128.287 76.8543Z",
    fill: "url(#paint0_linear_1912_493)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2629 113.918C55.0445 113.918 98.1928 114.424 118.685 114.424C123.981 84.5018 135.436 59.0164 150.278 41.8465C173.723 14.7242 204.085 4.521 220.293 1.20956H143.333C115.156 0.640326 54.5321 0.355709 37.4551 3.77111C16.1089 8.04036 -7.79891 37.0713 2.44729 70.3714C12.6935 103.672 44.2859 113.918 50.2629 113.918Z",
    fill: "url(#paint1_linear_1912_493)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.962 336.914V114.06C143.359 112.01 118.654 163.298 116.377 189.198C116.093 234.737 115.694 329.059 116.377 342.038C117.231 358.261 133.454 393.269 174.439 392.415C207.227 391.732 221.116 355.13 223.962 336.914Z",
    fill: "url(#paint2_linear_1912_493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1912_493",
    x1: 319.549,
    y1: 37.5772,
    x2: 141.095,
    y2: 105.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04FF1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1912_493",
    x1: 139.917,
    y1: 56.7097,
    x2: 0.00000253903,
    y2: 24.7695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04ACA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#04BC9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00FE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FE3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1912_493",
    x1: 169.981,
    y1: 114,
    x2: 197.116,
    y2: 392.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#006599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0697C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderT);
export default __webpack_public_path__ + "static/media/Loader T.89a67f1384cb647b450cb8b75fc40ab7.svg";
export { ForwardRef as ReactComponent };